import React from 'react'

const WorkerTermsAndConditions = () => {
    return (
        <div>
            <div className="bg-[#F0FDF8] py-10 md:py-16 px-4">
                <div className="container mx-auto max-w-4xl">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center leading-tight">
                        Worker Terms and Conditions
                    </h1>
                </div>
            </div>

            <div className="flex-grow container mx-auto pb-10 md:pb-16 px-4 sm:px-6">
                <div className="bg-white p-5 sm:p-8 md:p-12 max-w-4xl mx-auto">
                    <div>
                        <>
                            <p>
                                <span style={{ fontWeight: 400 }}>Last Updated: 01 March 2026</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>1. The Service Agreement</strong></p>
                            <p>&nbsp;</p>

                            <p><strong>1.1 Maidly as a Marketplace Platform</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Maidly provides a digital platform that connects individuals seeking residential or commercial home services including but not limited to cleaning, plumbing, electrical, maintenance, and related domestic services. (“Customers”) with independent third-party professionals (“Service Providers” or “Maids”).
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Non-Employment:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You acknowledge that Maidly does not provide home services including but not limited to cleaning, plumbing, electrical, maintenance, and related domestic services and does not employ Service Providers. Service Providers are independent contractors who choose their own hours and use their own methods to perform the work.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Contract of Service:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}When a Customer books a cleaning, a legal contract is formed directly between the Customer and the Service Provider. Maidly is not a party to that specific service contract but acts as the limited agent to facilitate the booking, communication, and payment.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>1.2 Scope of Services</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>The "Service" provided by Maidly is limited to:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Displaying available Service Providers based on your location.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Facilitating the scheduling and booking of cleanings.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Managing the secure payment gateway.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Providing a customer support channel for dispute resolution.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>1.3 Quality and Performance</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    While Maidly conducts background checks and identity verification for all Service Providers, we do not guarantee the specific quality of any individual cleaning.
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Standard of Care:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Service Providers are expected to perform duties with reasonable care and according to the "Service Description" selected by the Customer.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Exclusions:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Maidly and its Partners are not responsible for cleaning hazardous materials (biohazards, mold, pest infestations) or moving heavy furniture unless explicitly agreed upon in a "Premium" service tier.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>1.4 Modifications to Service</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Maidly reserves the right to modify, suspend, or discontinue any part of the App or Service at any time. We also reserve the right to refuse service to any user (Customer or Maid) who violates our community guidelines or safety protocols.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>2. User Accounts</strong></p>
                            <p>&nbsp;</p>

                            <p><strong>2.1 Account Creation</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    To access the services of Maidly, you must register for and maintain an active personal user account.
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Accuracy of Information:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You agree to provide and maintain information that is accurate, complete, and up-to-date. Failure to maintain accurate information may result in your inability to access the Services or our termination of your account.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>One Account Rule:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Each user is permitted to create only one account. The creation of multiple accounts to exploit promotional codes or bypass platform bans is strictly prohibited.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>2.2 Security and Credentials</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    You are responsible for maintaining the confidentiality of your account login credentials (OTP/Password).
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Unauthorized Use:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You are solely responsible for all activity that occurs under your account. If you suspect any unauthorized access, you must notify Maidly Support immediately.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Non-Transferability:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Your account is personal to you. You may not authorize third parties to use your account, nor may you assign or transfer your account to any other person.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>2.3 Account Verification</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Maidly reserves the right to verify the identity of any user at any time.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Verification Methods:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}This may include requesting a copy of a government ID, phone number verification via OTP, or email confirmation.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Refusal of Access:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We may refuse to open an account or may close an existing account if we believe the information provided is fraudulent or if the user poses a safety risk to our Service Providers.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>2.4 User Prohibitions &amp; Conduct</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>By creating an account, you agree that you will NOT:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Bypass the Platform:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Attempt to contact a Service Provider outside of the Maidly app to arrange services or payments (known as "Disintermediation"). This undermines our insurance and safety protocols.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Fake Bookings:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Create "test" or "fake" bookings that waste the time and resources of our cleaning partners.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Abuse:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Use the app to harass, threaten, or offend Service Providers or Maidly staff.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>False Reviews:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Post fraudulent, defamatory, or "paid-for" reviews about a Service Provider.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>2.5 Account Suspension and Termination</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Maidly reserves the right, in its sole discretion, to temporarily suspend or permanently terminate your account if:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>You breach these Terms and Conditions.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>You fail to pay for services rendered.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>We detect suspicious or fraudulent financial activity.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Your account has a consistently low rating from Service Providers (indicating you are a difficult or unsafe customer).</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>3. Bookings and Payments</strong></p>
                            <p>&nbsp;</p>

                            <p><strong>3.1 Booking Confirmation</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    A booking is considered "confirmed" only when it is accepted by a Service Provider and you receive a confirmation notification via the Maidly App.
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Scheduling:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}While we strive to meet your requested time slot, all bookings are subject to the availability of the Service Providers in your area.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Pricing Estimates:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The price displayed at the time of booking is based on the service type (e.g., "2-Bedroom Apartment") and the estimated time required. If the actual condition of the premises significantly differs from the description provided, the price may be adjusted with your consent.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>3.2 Payment Terms</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Pre-Authorization:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Upon booking, Maidly may place a temporary "hold" or "pre-authorization" on your credit card or wallet to ensure sufficient funds are available.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Final Charge:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The final payment is processed immediately upon the completion of the service as marked by the Service Provider in the app.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Taxes:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}All prices listed are inclusive of applicable taxes unless stated otherwise.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Platform Fees:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Maidly charges a "Service Fee" or "Platform Fee" for every booking. This fee covers the cost of background checks, app maintenance, and customer support. This fee is non-refundable once the service has started.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>3.3 Payment Methods</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    We use third-party payment processors (Razorpay) to ensure your financial data is secure. By using Maidly, you agree to:
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Provide a valid and authorized payment method.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Allow Maidly to charge that payment method for all services, cancellation fees, or damages (if applicable).</span>
                                </li>
                            </ul>
                            <p>
                                <span style={{ fontWeight: 400 }}>We request that you contact Maidly Support before initiating a chargeback so we can attempt to resolve the issue.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>3.4 In-App Tipping (Optional)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Customers may choose to provide a "Tip" to the Service Provider via the app.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>100% to the Maid:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Maidly does not take a commission from tips; 100% of the tip amount (minus any processing fees) is passed directly to the Service Provider.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>No Obligation:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Tipping is entirely voluntary and is not required to receive high-quality service.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>3.5 Cash Payments (Prohibition)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    To ensure safety and financial security, Cash Payments are strictly prohibited.  All transactions must occur through the Maidly App.
                                </span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    If you pay a Service Provider in cash, Maidly cannot provide a refund, insurance coverage, or dispute resolution for that booking. Furthermore, paying in cash is a violation of these Terms and may result in account termination.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>4. Cancellation and Refund Policy</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    At Maidly, we value the time of both our Customers and our Service Providers. Our cancellation policy is designed to be fair while ensuring our Partners are compensated for their readiness to work.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>4.1 Customer Cancellations</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    You may cancel or reschedule a booking through the App. However, the following fees apply based on the timing of your cancellation:
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>More than 24 hours before the service: No cancellation fee. You will receive a full refund to your original payment method or Maidly Wallet.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Between 2 hours and 24 hours before the service: A Partial Cancellation Fee of 15% of the total booking value will be charged.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Within 2 hours of the service: A Late Cancellation Fee of 50% will be charged. This fee is used to compensate the Service Provider for their travel time and the loss of other potential work.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>4.2 Rescheduling</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Rescheduling follows the same time windows as cancellations.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>If you reschedule more than 24 hours in advance, there is no charge.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Late rescheduling (within 2 hours) may incur a small convenience fee.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>4.3 Service Provider No-Shows</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If a Service Provider fails to arrive within 30 minutes of the scheduled start time:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>You are entitled to a 100% refund of the booking amount.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Alternatively, we can help you reschedule the service with a different provider at a discounted rate as an apology for the inconvenience.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>4.4 Refund Requests (Quality of Service)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    We want you to love your completed service. If you are unsatisfied with the quality of the service:
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Reporting Window:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You must report any issues via the "Help" section of the App within 24 hours of the service completion.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Evidence:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You must provide clear photos of the areas that were not cleaned according to the service description.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Resolution:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Maidly will investigate the claim. Resolutions may include a partial refund, a credit toward your next service, or a "re-service" of the specific area at no additional cost.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Finality:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}After 24 hours, the service is deemed accepted, and no refunds will be issued.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>4.5 Non-Refundable Situations</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Refunds will not be provided if:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>The Service Provider is unable to enter the premises (e.g., wrong gate code provided, no one home to let them in).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>The Customer asks the Maid to perform tasks outside the scope of the booked service.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>The Customer interferes with the Service Provider’s ability to complete the work in a timely manner.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>5. User Conduct and Safety</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    At Maidly, the safety of our Customers and Service Providers is our absolute priority. We maintain a zero-tolerance policy for any behavior that threatens the well-being of our community. Users may not attempt to hack, disrupt, reverse engineer, scrape data from, or interfere with the security of the App.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>5.1 Customer Responsibilities</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>To ensure a safe and productive environment, Customers agree to the following:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Safe Access:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You must provide safe and unobstructed access to the service area. This includes ensuring that floors are structurally sound and that there are no exposed electrical hazards.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Pet Policy:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}While we love pets, for the safety of our Service Providers, all pets must be secured in a crate or a separate room during the duration of the service, unless otherwise agreed upon in writing.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Climate Control:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You agree to provide a workspace with a reasonable temperature (e.g., functioning AC or heating) so the Service Provider can perform their duties safely.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Biohazards:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Our Service Providers are not trained to handle biohazardous materials. This includes, but is not limited to, human or animal waste, mold, needles, or chemical spills. Service Providers have the right to refuse service if such conditions are present.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>5.2 Professional Conduct &amp; Zero Tolerance</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Maidly maintains a strictly professional environment. The following behaviors will result in immediate and permanent account termination:
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Harassment:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Any form of verbal, physical, or sexual harassment toward a Service Provider is strictly prohibited.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Discrimination:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You may not discriminate against a Service Provider based on race, religion, gender, disability, or national origin.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Illegal Activities:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Customers may not use the App to facilitate any illegal activities. If a Service Provider discovers illegal items or activity on the premises, they are instructed to leave immediately and report the incident to Maidly and, if necessary, law enforcement.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>5.3 Service Provider Conduct</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Service Providers are also held to high standards. They agree to:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Professionalism:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Arrive on time, wear any required identification, and communicate respectfully with the Customer.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Privacy:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Respect the Customer’s privacy and only enter rooms that are part of the booked service area.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Prohibited Actions:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}They are strictly prohibited from bringing unauthorized guests (friends, children, or pets) to a job site.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>5.4 Reporting Incidents</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Emergency:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}In the event of an immediate threat to life or safety, always call local emergency services first.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Reporting to Maidly:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Any safety incident, property dispute, or misconduct must be reported via the "Safety Center" in the Maidly App within 6 hours of the incident. We investigate every report thoroughly.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>5.5 Masked Communication</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    To protect your privacy, Maidly uses Number Masking technology. Customers and Service Providers should only communicate through the App. Sharing private phone numbers or social media profiles is discouraged and is done at your own risk.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>6. Limitation of Liability</strong></p>
                            <p>&nbsp;</p>

                            <p><strong>6.1 The "As-Is" Nature of the Platform</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Maidly provides a platform to connect users, but we do not guarantee that the services will always be error-free or uninterrupted. Users and Service Providers agree to comply with all applicable Indian laws, including tax regulations, labor regulations, and consumer protection laws. To the maximum extent permitted by law, the Maidly App and its services are provided on an "as-is" and "as-available" basis.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>6.2 No Liability for Third-Party Actions</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Because Maidly is a marketplace and not the employer of the Service Providers:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Independent Acts:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Maidly is not responsible for the conduct, actions, or omissions of any Service Provider or Customer, whether online or offline.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Property Damage:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}While we vet our Partners, Maidly is a technology platform and does not directly provide services. However, we may assist in dispute resolution and, at our sole discretion, facilitate claims under any applicable partner protection policies. Any claims for damage must be resolved directly between the Customer and the Service Provider. (Maidly may, at its discretion, assist in mediation but is not legally obligated to pay for damages).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Personal Injury:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Maidly shall not be liable for any personal injury or property damage resulting from the use of the Services or the presence of a Service Provider in your home.</span>
                                </li>
                            </ul>
                            <p>
                                <span style={{ fontWeight: 400 }}>We encourage users to contact support in the event of disputes or losses, even if our liability is limited.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>6.3 Limitation of Monetary Damages</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>To the extent permitted by law, in no event shall Maidly be liable for:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Indirect Damages:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Any indirect, incidental, special, exemplary, punitive, or consequential damages.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Loss of Profits:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Loss of data, lost profits, or business interruption.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Maximum Cap:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}In any event, Maidly’s total liability to you for all claims arising out of the use of the App shall not exceed the total platform fee actually received by Maidly for the specific booking that gave rise to the claim.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>6.4 Items of High Value (Jewelry &amp; Cash)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Customers are strictly advised to secure and lock away all items of high monetary or sentimental value (e.g., jewelry, cash, small electronics, heirlooms) before the Service Provider arrives. Maidly shall not be responsible for loss of unsecured valuables to the extent permitted by applicable law.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>6.5 Indemnification</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    You agree to indemnify and hold Maidly, its officers, directors, and employees harmless from any and all claims, demands, losses, or expenses (including legal fees) arising out of:
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Your use of the Services.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Your breach of these Terms.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Your violation of the rights of any third party (including the Service Provider).</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>7. Service Provider (Maid) Specific Terms</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    By registering as a Service Provider on the Maidly platform, you acknowledge and agree to the following professional standards and legal obligations:
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>7.1 Independent Contractor Status</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>No Employment Relationship:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You are an independent contractor and not an employee of Maidly. Nothing in this agreement shall be construed as creating a partnership, joint venture, or employer-employee relationship.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Control:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You retain the right to accept or reject any booking request. You are responsible for determining the most effective manner to perform the home services including but not limited to cleaning, plumbing, electrical, maintenance, and related domestic services.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Taxes &amp; Insurance:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You are solely responsible for all tax obligations (Income Tax, GST, etc.) and for maintaining any necessary personal or business insurance.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>7.2 Service Standards &amp; Quality</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Professionalism:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You agree to perform all services in a professional, safe, and workmanlike manner.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Equipment:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Unless otherwise specified in the booking, you are responsible for providing your own cleaning supplies and equipment.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Reliability:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Once you accept a booking, you are expected to arrive on time. Frequent late arrivals or "no-shows" will result in a lowered rating and potential removal from the platform.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>7.3 Use of Customer Information</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Confidentiality:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You will be provided with the Customer’s name, address, and phone number. You agree to use this information only for the purpose of fulfilling the service booking.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Data Privacy:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You may not store, share, or use Customer data for any other purpose after the service is complete. Taking photos inside a Customer's home is strictly prohibited unless it is to document completed work or property damage.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>7.4 Non-Circumvention (The "Anti-Poaching" Rule)</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Off-Platform Bookings:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You agree not to solicit or accept direct payments from Customers introduced to you through Maidly.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Referrals:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If a Customer asks to book you privately (outside the app), you must direct them back to the Maidly App.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Penalties:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Bypassing the platform is a material breach of these terms and will result in permanent deactivation of your account and the forfeiture of any pending payouts.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>7.5 Payouts and Commissions</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Commission:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Maidly deducts a pre-agreed "Platform Fee" or commission from each booking. The remaining balance is your "Service Fee."</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Payment Cycle:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Payouts are processed on a weekly/monthly basis to your registered bank account, provided the service has been marked as "Complete" and no customer dispute has been raised.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Disputes:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If a Customer raises a valid complaint about service quality, Maidly reserves the right to withhold or deduct a portion of the payout to cover the cost of a re-clean or refund.</span>
                                </li>
                            </ul>
                            <p>
                                <span style={{ fontWeight: 400 }}>Maidly shall not be liable for delays or failure due to events beyond reasonable control including natural disasters, strikes, internet failures, government restrictions.</span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Maidly conducts identity verification of Service Providers; however, users should exercise reasonable caution. In case of emergency, contact local authorities immediately.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>8. Governing Law</strong></p>
                            <p>&nbsp;</p>

                            <p><strong>8.1 Choice of Law</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    These Terms and Conditions, and your relationship with Maidly, shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law principles.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>8.2 Jurisdiction</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Subject to the arbitration clause above, any legal proceedings permitted under applicable law shall be brought exclusively in the courts located in Jaipur, Rajasthan.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>8.3 Informal Dispute Resolution</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Before filing a formal legal claim, you agree to try to resolve the dispute informally by contacting Maidly Support at support@redqubes.com. We will attempt to resolve the issue via email or phone within 30 days. Most issues (like refund disputes or late arrivals) can be settled here without involving lawyers.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>8.4 Mandatory Arbitration</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    In the event that an informal resolution is not reached, both parties agree that the dispute shall be settled by binding arbitration in Jaipur, rather than in court. This arbitration clause does not limit any statutory rights available under Indian law, including rights under the Consumer Protection Act, 2019.
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>The arbitration shall be conducted in the English or Hindi language.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>The decision of the arbitrator shall be final and binding on both parties.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>8.5 Severability</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    If any provision of these Terms is found by a court to be invalid or unenforceable, that specific provision will be removed, and the rest of the Terms will remain in full force and effect.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>9. Updates</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    As Maidly grows and evolves, we may need to update these Terms and Conditions to reflect changes in the law, new app features, or shifts in our business practices.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>9.1 Right to Modify</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Maidly reserves the right to modify or replace these Terms at any time, in our sole discretion. This includes changes to pricing, cancellation fees, and service standards.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>9.2 Notification of Material Changes</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    If a revision is "material" (meaning it significantly changes your rights or obligations), we will provide at least 30 day notice before the new terms take effect. Notification will be provided via:
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>An in-app pop-up or notification.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>An email sent to your registered account.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>A "New Update" banner on our website.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>9.3 Acceptance of Updated Terms</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    By continuing to access or use the Maidly App after those revisions become effective, you agree to be bound by the updated Terms. If you do not agree to the new terms, you must stop using the platform and may request to close your account.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>9.4 Software Updates</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Maidly may automatically download and install updates to the App on your device. These updates are designed to improve, enhance, and further develop the Service and may take the form of bug fixes, enhanced functions, or new software modules. You agree to receive such updates as part of your use of the Service.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>10. Intellectual Property</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    All content, trademarks, logos, designs, software, and intellectual property related to Maidly are owned by or licensed to Maidly. Users may not copy, reproduce, distribute, modify, reverse engineer, or exploit any part of the App without prior written consent.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>11. Privacy Policy</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Your use of the Maidly App is also governed by our Privacy Policy, which explains how we collect, use, and protect your personal data. The Privacy Policy is available on our website and within the App.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>12. Contact Us</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    We believe in open communication. If you have questions about these Terms and Conditions, your data rights, or how we handle your home’s security, please use the specific channels below to ensure your inquiry reaches the right department.
                                </span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    For questions regarding how we use your data, requests for data access, or updates to your personal information:
                                </span>
                            </p>
                            <p>
                                <strong>Email:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}support@redqubes.com</span>
                            </p>
                            <p>
                                <strong>Phone:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}+91 92576 52266</span>
                            </p>
                            <p>
                                <strong>Response Time:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}We aim to respond to all privacy-related inquiries within 24–48 hours.</span>
                            </p>

                        </>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WorkerTermsAndConditions